{
  "currencies": {
    "title": "العملات",
    "add": "إضافة عملة",
    "columns": {
      "nameAr": "الاسم بالعربية",
      "nameEn": "الاسم بالإنجليزية",
      "code": "رمز العملة",
      "status": "الحالة"
    },
    "rowActions": {
      "trigger": "إجراءات {{name}}"
    },
    "drawer": {
      "createTitle": "إضافة عملة",
      "editTitle": "تعديل العملة",
      "createDescription": "أضف عملة جديدة لاستخدامها في الأمانات.",
      "editDescription": "تحديث بيانات هذه العملة.",
      "fields": {
        "nameAr": "الاسم بالعربية",
        "nameEn": "الاسم بالإنجليزية",
        "code": "رمز العملة",
        "status": "الحالة"
      },
      "codeHint": "مثال: JOD أو USD",
      "inUseNotice": "لا يمكن تغيير الرمز بعد استخدام العملة في أمانة",
      "created": "تم إنشاء العملة بنجاح",
      "updated": "تم تحديث العملة بنجاح"
    },
    "statusConfirmTitle": "تغيير حالة {{name}}؟",
    "statusChanged": "تم تغيير حالة العملة بنجاح"
  },
  "settings": {
    "title": "إعدادات الأمانات",
    "description": "النصوص الظاهرة في وصل الإيداع والتابلت.",
    "fields": {
      "organisationNameAr": "اسم المؤسسة بالعربية",
      "organisationNameEn": "اسم المؤسسة بالإنجليزية",
      "receiptHeaderAr": "ترويسة الوصل بالعربية",
      "receiptHeaderEn": "ترويسة الوصل بالإنجليزية",
      "depositDeclarationAr": "إقرار الإيداع بالعربية",
      "depositDeclarationEn": "إقرار الإيداع بالإنجليزية",
      "deliveryAcknowledgementAr": "إقرار التسليم بالعربية",
      "deliveryAcknowledgementEn": "إقرار التسليم بالإنجليزية",
      "receiptFooterAr": "تذييل الوصل بالعربية",
      "receiptFooterEn": "تذييل الوصل بالإنجليزية"
    },
    "readOnlyNotice": "ليس لديك صلاحية لتعديل هذه الإعدادات",
    "saved": "تم حفظ الإعدادات بنجاح",
    "discardTitle": "تجاهل التغييرات؟",
    "discardDescription": "ستفقد التغييرات غير المحفوظة.",
    "unsavedChanges": "لديك تغييرات غير محفوظة",
    "phoneVerification": "تأكيد رقم الهاتف برمز واتساب",
    "phoneVerificationHelp": "يرسل رمز عبر واتساب عند إضافة عميل أو تغيير رقم الهاتف. ولا يتم الحفظ إلا بعد إدخال الرمز."
  }
}
